import { LocalModule } from '../../interfaces/LocalModule';
import { Remote } from '../../interfaces/Remote';
import InterhypDashboardRedirectModule from '../../modules/./InterhypDashboardRedirect/InterhypDashboardRedirect.module';

export const remotes: Remote[] = [
  {
    name: 'module_dashboard',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-dashboard/remoteEntry.js',
  },
  {
    name: 'plugin_interhyp',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/plugin-interhyp/remoteEntry.js',
  },
  {
    name: 'module_registration',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-registration/remoteEntry.js',
  },
  {
    name: 'module_omnichannel',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-omnichannel/remoteEntry.js',
  },
  {
    name: 'module_dashboard',
    imports: ['./ProfessionalDashboardConfigTest', './InterhypWidgets'],
    source: '/remotes/module-dashboard/remoteEntry.js',
    onlyOnStages: ['dev'],
  },
];

export const modules: LocalModule[] = [{ module: InterhypDashboardRedirectModule }];
